module.exports = __webpack_public_path__ + "static/media/editor-icon-unordered-list-active.798ed9f8.svg";